
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import ListContainer from "../components/shared/ListContainer.vue";
import MultiMovies from "../components/shared/MultiMovies.vue";
import years from "../years";
import { ISong, ILive } from "../@types/interface.d";

interface DataType {
  song?: ISong;
  lives?: { [key: string]: ILive[] };
  years: number[];
  currentYear: number;
}

interface MethodType {
  init: () => void;
  badgeClass: () => string;
  yearClick: () => void;
}

interface ComputedType {
  youtubeUrl: string;
}

export default Vue.extend({
  name: "songDetail",
  components: {
    Headline,
    ListContainer,
    MultiMovies,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      song: undefined,
      lives: undefined,
      years,
      currentYear: new Date().getFullYear(),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { id } = this.$route.params;
      fetch(`/api/songs/${id}`).then(res => res.json()).then((data: { song: ISong, lives: { [key: string] : ILive[] }}) => {
        this.lives = data.lives;
        this.song = data.song;
        if (data.lives[this.currentYear.toString()].length === 0) {
          this.currentYear -= 1;
        }
      });
    },
    badgeClass(year: number): string {
      return year === this.currentYear ? "badge-primary" : "badge-secondary";
    },
    yearClick(year: number): void {
      this.currentYear = year;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
